import { Form, message } from 'antd'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { Props } from '.'
import {
  ExpressCompanyRes,
  GET_EXPRESSCOMPANY_LIST,
} from '../../../../api/orderManage'
import { expressType } from '../../../../tools/state'
import { fileFile } from '../../../../modules/uploadfiles/hooks'
import moment from 'moment'
import { isResponseCodeSuccess } from '../../../../tools/util'

export function useSetupHook(props: Props) {
  const { handleSumitSuccess, open, editIndex, ticketList } = props
  const [form] = Form.useForm()
  const [uploadFilesList, setUploadFilesList] = useState<fileFile[]>([])
  const [expressList, setExpressList] = useState<ExpressCompanyRes[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadFilesList(e)
    form.setFieldsValue({
      fileList: e,
    })
  }
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    if (uploadFilesList.length < 1) {
      message.warning('请上传发票')
      return
    }
    setIsLoading(true)
    handleSumitSuccess?.(
      {
        fileIdList: uploadFilesList.map((item) => item.id ?? ''),
        ...(formValues as any),
        invoiceTime: formValues.invoiceTime?.valueOf(),
      },
      editIndex,
    )
    setIsLoading(false)
  }
  const getExpressList = async () => {
    const res = await GET_EXPRESSCOMPANY_LIST({
      type: expressType,
    })
    if (isResponseCodeSuccess(res.code)) {
      setExpressList(res.data)
    }
  }

  useEffect(() => {
    getExpressList()
  }, [])

  function loadEditState(index: number) {
    const info = ticketList[index]
    form.setFieldsValue({
      ..._.omit(info, ['fileIdList']),
      invoiceTime: info.invoiceTime ? moment(info.invoiceTime) : null,
    })
    setUploadFilesList(info.fileList)
  }

  useEffect(() => {
    if (open) {
      loadEditState(editIndex)
    } else {
      form.resetFields()
      setUploadFilesList([])
    }
    // eslint-disable-next-line
  }, [open])

  return {
    form,
    uploadFilesList,
    expressList,
    isLoading,
    handleUploadfilesChange,
    handleSubmit,
  }
}
import { Form, message } from 'antd'
import _ from 'lodash'
import { useEffect, useState } from 'react'
import { Props } from '.'
import {
  ExpressCompanyRes,
  GET_EXPRESSCOMPANY_LIST,
} from '../../../../api/orderManage'
import { expressType } from '../../../../tools/state'
import { fileFile } from '../../../../modules/uploadfiles/hooks'
import moment from 'moment'
import { isResponseCodeSuccess } from '../../../../tools/util'

export function useSetupHook(props: Props) {
  const { handleSumitSuccess, open, editIndex, ticketList } = props
  const [form] = Form.useForm()
  const [uploadFilesList, setUploadFilesList] = useState<fileFile[]>([])
  const [expressList, setExpressList] = useState<ExpressCompanyRes[]>([])
  const [isLoading, setIsLoading] = useState(false)

  const handleUploadfilesChange = (e: fileFile[]) => {
    setUploadFilesList(e)
    form.setFieldsValue({
      fileList: e,
    })
  }
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    if (uploadFilesList.length < 1) {
      message.warning('请上传发票')
      return
    }
    setIsLoading(true)
    handleSumitSuccess?.(
      {
        fileIdList: uploadFilesList.map((item) => item.id ?? ''),
        ...(formValues as any),
        invoiceTime: formValues.invoiceTime?.valueOf(),
      },
      editIndex,
    )
    setIsLoading(false)
  }
  const getExpressList = async () => {
    const res = await GET_EXPRESSCOMPANY_LIST({
      type: expressType,
    })
    if (isResponseCodeSuccess(res.code)) {
      setExpressList(res.data)
    }
  }

  useEffect(() => {
    getExpressList()
  }, [])

  function loadEditState(index: number) {
    const info = ticketList[index]
    form.setFieldsValue({
      ..._.omit(info, ['fileIdList']),
      invoiceTime: info.invoiceTime ? moment(info.invoiceTime) : null,
    })
    setUploadFilesList(info.fileList)
  }

  useEffect(() => {
    if (open) {
      loadEditState(editIndex)
    } else {
      form.resetFields()
      setUploadFilesList([])
    }
    // eslint-disable-next-line
  }, [open])

  return {
    form,
    uploadFilesList,
    expressList,
    isLoading,
    handleUploadfilesChange,
    handleSubmit,
  }
}
